/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ThirdPartiesFormsAndHandbooksInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Forms and Handbooks for Nova Scotia Election Third Parties"
              description={
                <>
                  <h3>Handbook</h3>

                  <ul style={{ paddingLeft: "40px" }}>
                    <li>
                      <p><a href="/files/Forms&Handbooks/ThirdParty/Handook%20for%20the%20Financial%20Agent%20of%20a%20Third%20Party%20Oct%202012%20v2.pdf">Handook for the Financial Agent of a Third Party</a></p>
                    </li>
                  </ul>

                  <p>&nbsp;</p>

                  <h3>Forms</h3>

                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/Forms&Handbooks/ThirdParty/Form%207-1%20Sept%204%202013%20%282%29.pdf">Form 7-1 Third Party Registration Application</a></li>
                    <li><a href="/files/Forms&Handbooks/ThirdParty/Form 7-2 Third Party Advertising Report.pdf">Form 7-2 Third Party Advertising Report</a>&nbsp;</li>
                  </ul>

                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ThirdPartiesFormsAndHandbooksInformation;
